import commonConstant from '../../common/_commonConstant';
import { getCookieToken, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetParkingDayConfig = (buildingID, dayTypes, from, to, offset, limit, sortBy, orderBy) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parking-day-configs/${buildingID}?dayTypes=${dayTypes}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}${offset ? `&offset=${offset}` : ''}${limit ? `&limit=${limit}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${orderBy ? `&orderBy=${orderBy}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();
  
      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PARKING_DAY_CONFIG_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorParkingNotFound) {
        return dispatch({
          'type': commonConstant.GET_PARKING_DAY_CONFIG_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PARKING_DAY_CONFIG_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PARKING_DAY_CONFIG_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchUpdateParkingDayConfig = (updateParkingConfigDate) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parking-day-configs/parking-day-config-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,       
        }),
        'method': 'PUT',
        'body': JSON.stringify(updateParkingConfigDate),
      });
      const data = await res.json();
  
      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_PARKING_DAY_CONFIG_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorParkingNotFound) {
        return dispatch({
          'type': commonConstant.UPDATE_PARKING_DAY_CONFIG_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_PARKING_DAY_CONFIG_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_PARKING_DAY_CONFIG_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchCreateParkingDayConfig = (createParkingDayConfigForm) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/parking-day-configs/parking-day-config-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,       
        }),
        'method': 'POST',
        'body': JSON.stringify(createParkingDayConfigForm),
      });
      const data = await res.json();
  
      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_PARKING_DAY_CONFIG_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorParkingNotFound) {
        return dispatch({
          'type': commonConstant.CREATE_PARKING_DAY_CONFIG_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_PARKING_DAY_CONFIG_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_PARKING_DAY_CONFIG_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);
